export const TABS = [
  {
    value: "reservations" as const,
    labelKey: "reservations.tabs.reservations",
    icon: "event",
  },
  {
    value: "requests" as const,
    labelKey: "reservations.tabs.requests",
    icon: "mail",
  },
] as const;

export type TabValue = (typeof TABS)[number]["value"];

export interface TabConfig {
  type: "reservation" | "request";
  emptyTitleKey: string;
  emptyDescriptionKey: string;
  errorTitleKey: string;
}

export const TAB_CONFIG: Record<TabValue, TabConfig> = {
  reservations: {
    type: "reservation",
    emptyTitleKey: "reservations.history.no_past_reservations",
    emptyDescriptionKey: "reservations.history.no_reservations_period",
    errorTitleKey: "reservations.history.failed_load_reservations",
  },
  requests: {
    type: "request",
    emptyTitleKey: "reservations.history.no_past_requests",
    emptyDescriptionKey: "reservations.history.no_requests_period",
    errorTitleKey: "reservations.history.failed_load_requests",
  },
};
